import { render, staticRenderFns } from "./QuestionShort.vue?vue&type=template&id=a0ae54f6&scoped=true&"
import script from "./QuestionShort.vue?vue&type=script&lang=js&"
export * from "./QuestionShort.vue?vue&type=script&lang=js&"
import style0 from "./QuestionShort.vue?vue&type=style&index=0&id=a0ae54f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ae54f6",
  null
  
)

export default component.exports